export default "__VITE_ASSET__CP14PWha__"